import Vue from "vue";

import "@/app/css/public.css";

// import app_header from "@/app/components/header/header";
// import app_footerNav from "@/app/components/footerNav/footerNav";
// import app_collapse from "@/app/script/collapse.js";

// Vue.component("app-header", app_header);
// Vue.component("app-footer-nav", app_footerNav);
// Vue.component("app-collapse", app_collapse);

import home_index_page from "@/app/pages/home/index/index";
import home_search_page from "@/app/pages/home/search/search";
import model_comparison from "@/app/pages/home/carCompare/index";
import model_list_page from "@/app/pages/model/list/list";
import model_league from "@/app/pages/model/list/league";
import model_release_page from "@/app/pages/model/release/release";
import model_detail_page from "@/app/pages/model/detail/detail";
import topic_list_page from "@/app/pages/topic/list/list";
import topic_release_page from "@/app/pages/topic/release/release";
import topic_detail_page from "@/app/pages/topic/detail/detail";
import material_list_page from "@/app/pages/material/list/list";
import material_upload_page from "@/app/pages/material/upload/upload";
import material_detail_page from "@/app/pages/material/detail/detail";
import message_index_page from "@/app/pages/message/index/index";
import admin_index_page from "@/app/pages/admin/index/index";
import admin_detail_page from "@/app/pages/admin/detail/detail";
import admin_release_page from "@/app/pages/admin/release/release";
import me_index_page from "@/app/pages/me/index/index";
import me_user_page from "@/app/pages/me/user/user";
import me_collectList_page from "@/app/pages/me/collectList/collectList";

import question_message_page from "@/app/pages/question/message";
import question_message_record_page from "@/app/pages/question/message/record";
import question_task_page from "@/app/pages/question/task";
import question_task_record_page from "@/app/pages/question/task/record";

export default [
	{
		name: "question_message",
		path: "/question/message",
		component: question_message_page,
		meta: {
			title: "我的消息"
		}
	},
	{
		name: "question_message_record",
		path: "/question/message/record",
		component: question_message_record_page,
		meta: {
			title: "消息详情"
		}
	},
	{
		name: "question_task",
		path: "/question/task",
		component: question_task_page,
		meta: {
			title: "我的任务"
		}
	},
	{
		name: "question_task_record",
		path: "/question/task/record",
		component: question_task_record_page,
		meta: {
			title: "任务详情"
		}
	},



	{
		path: '/project/form/view',
		meta: { requireLogin: false },
		component: () => import(/* webpackChunkName: 'root' */ '@/pc/pages/form/preview/ProjectForm.vue')
	},
	/* {
		path: '/project/public/result',
		meta: { requireLogin: false },
		component: () => import('@/pc/pages/form/statistics/public')
	}, */
	{
		path: '/s/:key',
		meta: { requireLogin: false },
		component: () => import(/* webpackChunkName: 'root' */ '@/pc/pages/form/write')
	},
	{
		path: '/project/write',
		meta: { requireLogin: false },
		component: () => import(/* webpackChunkName: 'root' */ '@/pc/pages/form/write')
	},

	

	/* {
		name: "home_index",
		path: "/",
		component: home_index_page,
		meta: {
			title: "首页"
		}
	}, */
	{
		name: "home_search",
		path: "/home/search",
		component: home_search_page,
		meta: {
			title: "首页搜索结果"
		}
	},
	{
		name: "model_comparison",
		path: "/model/comparison",
		component: model_comparison,
		meta: {
			title: "车型对比"
		}
	},
	{
		name: "model_list",
		path: "/model/list",
		component: model_list_page,
		meta: {
			title: "车型列表"
		}
	},
	{
		name: "model_league",
		path: "/model/league",
		component: model_league,
		meta: {
			title: "积分榜"
		}
	},
	{
		name: "model_release",
		path: "/model/release",
		component: model_release_page,
		meta: {
			title: "车型提问"
		}
	},
	{
		name: "model_detail",
		path: "/model/detail",
		component: model_detail_page,
		meta: {
			title: "车型详情"
		}
	},
	{
		name: "topic_list",
		path: "/topic/list",
		component: topic_list_page,
		meta: {
			title: "话题列表"
		}
	},
	{
		name: "topic_release",
		path: "/topic/release",
		component: topic_release_page,
		meta: {
			title: "话题提问"
		}
	},
	{
		name: "topic_detail",
		path: "/topic/detail",
		component: topic_detail_page,
		meta: {
			title: "话题详情"
		}
	},
	{
		name: "material_list",
		path: "/material/list",
		component: material_list_page,
		meta: {
			title: "下载/播放列表"
		}
	},
	{
		name: "material_upload",
		path: "/material/upload",
		component: material_upload_page,
		meta: {
			title: "上传附件"
		}
	},
	{
		name: "material_detail",
		path: "/material/detail",
		component: material_detail_page,
		meta: {
			title: "下载/播放详情"
		}
	},
	{
		name: "message_index",
		path: "/message",
		component: message_index_page,
		meta: {
			title: "提醒首页"
		}
	},
	{
		name: "admin_index",
		path: "/admin",
		component: admin_index_page,
		meta: {
			title: "管理首页"
		}
	},
	{
		name: "admin_detail",
		path: "/admin/detail",
		component: admin_detail_page,
		meta: {
			title: "管理详情"
		}
	},
	{
		name: "admin_release",
		path: "/admin/release",
		component: admin_release_page,
		meta: {
			title: "管理回答"
		}
	},
	{
		name: "me_index",
		path: "/me",
		component: me_index_page,
		meta: {
			title: "个人中心首页"
		}
	},
	{
		name: "me_user",
		path: "/me/user",
		component: me_user_page,
		meta: {
			title: "已关注老师详情页"
		}
	},
	{
		name: "me_collectList",
		path: "/me/collectList",
		component: me_collectList_page,
		meta: {
			title: "收藏列表"
		}
	}
	/* {
		name: "home_index",
		path: "*",
		component: home_index_page,
		meta: {
			title: "首页"
		}
	} */
];



// WEBPACK FOOTER //
// ./src/router/app.js